<template>
  <div v-if="isMultiChoice" class="option-section">
    <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>

    <SiteFacingMultiChoiceMulti v-if="isMulti" :question="question" is-read-only />
    <SiteFacingMultiChoiceSingle v-if="isSingle" :question="question" is-read-only />
  </div>
</template>

<script>
import SiteFacingMultiChoiceSingle
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-single.vue";
import SiteFacingMultiChoiceMulti
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-multi.vue";
import * as MultiChoiceService from "@/components/common/multi-choice/multi-choice-service";

export default {
  name: "site-facing-read-only-wrapper",
  components: { SiteFacingMultiChoiceMulti, SiteFacingMultiChoiceSingle },
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isMultiChoice() {
      return MultiChoiceService.isMultiChoice(this.question);
    },
    isMulti() {
      return MultiChoiceService.isMulti(this.question);
    },
    isSingle() {
      return MultiChoiceService.isSingle(this.question);
    }
  }
};
</script>

<style lang="scss" scoped>
.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.question_body {
  word-break: break-all;
  color: #959fa4;
}
</style>
